const active = (currentUser)=>!!(currentUser && currentUser.active);
export default active;
